import { Identifiable, QueryParams, SortOption } from "..";

export interface Tenant extends Identifiable {
    name: string;
    logoUri: string;
    isActive: boolean;
    parentTenantId?: number;
}

export const isParentTenant = (tenant: Tenant) => {
    return !tenant.parentTenantId;
};

export const DefaultTenantQueryParams: QueryParams = {
    name: "",
    parentTenantId: "",
};

export const DefaultTenantSortParams = {
    orderBy: "name",
    orderDesc: "false",
};

export const tenantSortOptions: SortOption[] = [
    { value: "name", label: "Name (A-Z)", orderDesc: "false" },
    { value: "name", label: "Name (Z-A)", orderDesc: "true" },
    { value: "parentTenantId", label: "Parent Tenant (A-Z)", orderDesc: "false" },
    { value: "parentTenantId", label: "Parent Tenant (Z-A)", orderDesc: "true" },
];
